import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import Navbar from "@src/views/TuneIn/Navbar";
import Footer from "@src/views/TuneIn/Footer";
import Home from "@src/views/TuneIn/home";
import AboutUs from "@src/views/TuneIn/about_us";
import Schedule from "@src/views/TuneIn/schedule";
import Emissions from "@src/views/TuneIn/emission";
import EmissionByCategory from "@src/views/TuneIn/emission/EmissionByCategory/index.js";
import EmissionByTag from "@src/views/TuneIn/emission/EmissionByTag/index.js";
import EmissionId from "@src/views/TuneIn/emission/emission_id";
import Smartend from "@src/views/TuneIn/smartend";
import EpisodeByCategory from "@src/views/TuneIn/Episode/EpisodeByCategory/index.js";
import EpisodeByTags from "@src/views/TuneIn/Episode/EpisodebyTag/index.js";
import EisodeByClassification from "@src/views/TuneIn/Episode/EpisodeByClassification/index.js";
import EmissionByClassification from "@src/views/TuneIn/emission/EmissionByClassification/index.js";
import SmartendId from "@src/views/TuneIn/smartend/smartend_id";
import TopicByUserId from "@src/views/TuneIn/smartend/topic_by_user";
import Podcast from "@src/views/TuneIn/podcast";
import PodcastId from "@src/views/TuneIn/podcast/podcast_id";
import Playlist from "@src/views/TuneIn/playlist";
import PlaylistbyCategory from "@src/views/TuneIn/playlist/playlistByCategory.js";
import PlaylistId from "@src/views/TuneIn/playlist/playlist_id";
import VoteContainer from "@src/views/Ushno/widgets/Vote/VoteContainer.js";
import Gallery from "@src/views/TuneIn/gallery";
import GalleryId from "@src/views/TuneIn/gallery/gallery_id";
import GalleryByUser from "@src/views/TuneIn/gallery/gallery_by_user";
import Videos from "@src/views/TuneIn/video";
import VideoId from "@src/views/TuneIn/video/video_id";
import Team from "@src/views/TuneIn/team";
import ContactUs from "@src/views/TuneIn/contact_us";
import Publicity from "@src/views/TuneIn/pub";
import QuestionLisByid from "@src/views/Ushno/widgets/Vote/QuestionListByid.js";
import weatherwidgets from "@src/views/Ushno/widgets/weatherWidgets.js";
import MoneyConvertwidgets from "@src/views/Ushno/widgets/MoneyConvertWidgets.js";
import Holydayswidgets from "@src/views/Ushno/widgets/HolydaysWidgets.js";
import Horoscopeswidgets from "@src/views/Ushno/widgets/HoroscopWidgets.js";
import QuizList from "@src/views/Ushno/widgets/quiz/quizlist/QuizList.js";
import QuizItem from "@src/views/Ushno/widgets/quiz/quizItem/QuizItem.js";
import Error from "@src/views/TuneIn/Error";
import AudioPlayer from "@src/views/audio_player";
import { useBgColor } from "@hooks/useBgColor";
import { useBanner } from "@hooks/useBanner";
import { useSelector } from "react-redux";
import { useNavBar } from "@hooks/useNavBar";

const TuneInRoute = () => {
  const { setBgColor } = useBgColor();
  const { setBanner } = useBanner();
  const { setNavBar } = useNavBar();
  const RadioReducer = useSelector((state) => state.RadioReducer);
  const FrontofficeThemeReducer = useSelector(
    (state) => state.FrontofficeThemeReducer
  );
  const plyr__videowrapper = document.getElementsByClassName(
    "plyr__video-wrapper"
  );
  const [isloadind, setIsloadind] = useState(false);
  const [playerPause, setPlayerPause] = useState(true);
  const [isRoomExist, setisRoomExist] = useState(false);
  const isPaused = () => {
    setPlayerPause(true);
  };
  const isPlayed = () => {
    setPlayerPause(false);
  };
  const onpenVideoPlayer = (x) => {
    for (var i = 0; i < plyr__videowrapper.length; i++) {
      plyr__videowrapper[i].style.display = x;
    }
  };
  const onpenVideoFullScreen = (x) => {
    for (var i = 0; i < plyr__videowrapper.length; i++) {
      plyr__videowrapper[i].style.top = x;
    }
  };
  useEffect(() => {
    if (FrontofficeThemeReducer?.design_by_radio) {
      const designRadio = FrontofficeThemeReducer?.design_by_radio;
      if (designRadio?.templates?.id === 2) {
        const bgColor = designRadio.backgroundcolors.name;

        if (bgColor === "#502D75") {
          setBgColor(bgColor);
        } else if (bgColor === "white") {
          const tuneInTheme = localStorage.getItem("tuneIn_theme");
          setBgColor(tuneInTheme === "dark" ? "dark" : "white");
        }
      }
      setBanner(FrontofficeThemeReducer?.design_by_radio.banners.id);
      setNavBar(FrontofficeThemeReducer?.design_by_radio.navbars.id);
    }
    document.body.removeAttribute("class");
  }, [FrontofficeThemeReducer?.design_by_radio]);

  return (
    <div className="TuneIn">
      <Navbar />
      <Switch>
        <Route
          path="/"
          exact
          render={() => (
            <Home
              playerPause={playerPause}
              isPaused={isPaused}
              isPlayed={isPlayed}
              isloadind={isloadind}
              setIsloadind={setIsloadind}
              RadioReducer={RadioReducer}
              isRoomExist={isRoomExist}
            />
          )}
        />
        <Route path="/about-us" exact component={AboutUs} />
        <Route path="/schedule" exact component={Schedule} />
        <Route path="/emissions" exact component={Emissions} />
        <Route
          path="/emissions/category/:slug"
          exact
          component={EmissionByCategory}
        />
        <Route path="/emissions/tag/:slug" exact component={EmissionByTag} />
        <Route
          path="/emissions/classification/:slug/:name"
          exact
          component={EmissionByClassification}
        />
        <Route exact path="/emission/:id" component={EmissionId} />
        <Route
          path="/episode/category/:slug"
          exact
          component={EpisodeByCategory}
        />
        <Route path="/episode/tag/:slug" exact component={EpisodeByTags} />
        <Route
          path="/episode/classification/:slug/:name"
          exact
          component={EisodeByClassification}
        />
        <Route path="/team" exact component={Team} />
        <Route path="/podcast" exact component={Podcast} />
        <Route exact path="/podcast/:id" component={PodcastId} />
        <Route exact path="/widgets/vote/:id" component={VoteContainer} />
        <Route path="/playlists" exact component={Playlist} />
        <Route
          path="/playlists/category/:id"
          exact
          component={PlaylistbyCategory}
        />
        <Route exact path="/playlist/:id" component={PlaylistId} />
        <Route exact path="/widgets/vote/:id" component={VoteContainer} />
        <Route exact path={"/Quiz/QuizList"} component={QuizList} />
        <Route exact path={"/Quiz/QuizList/:id"} component={QuizItem} />
        <Route
          exact
          path={"/vote/question/:vote_id"}
          component={QuestionLisByid}
        />
        <Route
          path="/dataNews/:webmasterTitle/topics"
          exact
          component={Smartend}
        />
        <Route
          exact
          path="/dataNews/:webmasterTitle/topics/:id"
          component={SmartendId}
        />
        <Route
          exact
          path="/dataNews/:webmasterTitle/topics/created_by/:user_id"
          component={TopicByUserId}
        />
        <Route path="/Gallery/Photos/topics" exact component={Gallery} />
        <Route exact path="/Gallery/Photos/topics/:id" component={GalleryId} />
        <Route
          exact
          path="/Gallery/Photos/topics/created_by/:user_id"
          component={GalleryByUser}
        />
        <Route path="/Gallery/Videos/topics" exact component={Videos} />
        <Route exact path="/Gallery/Videos/topics/:id" component={VideoId} />
        <Route path="/contact-us" exact component={ContactUs} />
        <Route exact path="/widgets/weather/:id" component={weatherwidgets} />
        <Route
          exact
          path={"/widgets/holydays/:id"}
          component={Holydayswidgets}
        />
        <Route
          exact
          path={"/widgets/moneyConvert/:id"}
          component={MoneyConvertwidgets}
        />
        <Route
          exact
          path={"/widgets/horoscope/:id"}
          component={Horoscopeswidgets}
        />

        <Route path="*" component={Error} />
      </Switch>
      <Footer />
      <div className="adsPlayerTunein">
        <Publicity />
      </div>
      <AudioPlayer
        onpenVideoPlayer={onpenVideoPlayer}
        onpenVideoFullScreen={onpenVideoFullScreen}
        playerPause={playerPause}
        isPaused={isPaused}
        isPlayed={isPlayed}
        isloadind={isloadind}
        setIsloadind={setIsloadind}
        RadioReducer={RadioReducer}
        setisRoomExist={setisRoomExist}
      />
    </div>
  );
};

export default TuneInRoute;
